export default function appInIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}
